var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-product-document-list"},_vm._l((_vm.supportDocuments),function(document){return _c('document-unit',{key:document.id,attrs:{"document":document}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }